import smsCode from '@/api/sms_code';
import coach from '@/api/coach';

import { FETCH_CAPTCHA, REQUEST_SMS_CODE, SMS_CODE_COUNTER_RESET, SMS_CODE_COUNTER_TICK, LOGIN } from './types';

export default {
    [FETCH_CAPTCHA]({ commit }) {
        return smsCode.captcha()
            .then((resp) => {
                commit(FETCH_CAPTCHA, resp);
            });
    },
    [REQUEST_SMS_CODE]({ dispatch, state }, payload) {
        const { phone, captcha } = payload;
        return smsCode.login({
            phone,
            captcha,
            captchaTag: state.captchaTag,
        })
            .then(() => {
                dispatch(SMS_CODE_COUNTER_RESET);
            });
    },
    [SMS_CODE_COUNTER_RESET]({ dispatch, commit }) {
        commit(SMS_CODE_COUNTER_RESET);
        setTimeout(() => dispatch(SMS_CODE_COUNTER_TICK), 1000);
    },
    [SMS_CODE_COUNTER_TICK]({ dispatch, commit, state }) {
        commit(SMS_CODE_COUNTER_TICK);
        if (state.countdown > 0) {
            setTimeout(() => dispatch(SMS_CODE_COUNTER_TICK), 1000);
        }
    },
    [LOGIN]({ commit }, payload) {
        return coach
            .login(payload)
            .then((resp) => {
                commit(LOGIN, resp);
            });
    },
};



// WEBPACK FOOTER //
// ./src/store/auth/actions.js